import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { AdminRoleGuard } from './core/auth/guards/AdminRoleGuard';

export const appRoutes: Route[] = [
    { path: '', pathMatch: 'full', redirectTo: 'dashboard' },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'confirmation-required',
                loadChildren: () =>
                    import(
                        'app/modules/auth/confirmation-required/confirmation-required.routes'
                    ),
            },
            {
                path: 'forgot-password',
                loadChildren: () =>
                    import(
                        'app/modules/auth/forgot-password/forgot-password.routes'
                    ),
            },
            {
                path: 'reset-password',
                loadChildren: () =>
                    import(
                        'app/modules/auth/reset-password/reset-password.routes'
                    ),
            },
            {
                path: 'sign-in',
                loadChildren: () =>
                    import('app/modules/auth/sign-in/sign-in.routes'),
            },
            {
                path: 'sign-up',
                loadChildren: () =>
                    import('app/modules/auth/sign-up/sign-up.routes'),
            },
            {
                path: 'onboarding',
                loadChildren: () =>
                    import('app/modules/onbording/onbording.routing'),
            },
            {
                path: 'crm-onboarding',
                loadChildren: () =>
                    import(
                        'app/modules/crm-onboarding/crm-onboarding/crm-onboarding.routing'
                    ),
            },
        ],
    },
    {
        path: '',
        canActivate: [AdminRoleGuard],
        component: LayoutComponent,
        data: {
            layout: 'classic',
        },
        children: [
            {
                path: 'dashboard',
                loadChildren: () =>
                    import('app/modules/dashboard/dashboard.routing'),
            },
            {
                path: 'scope',
                loadChildren: () => import('app/modules/scope/scope.routing'),
            },
            {
                path: 'region',
                loadChildren: () => import('app/modules/region/region.routing'),
            },
            {
                path: 'application',
                loadChildren: () =>
                    import('app/modules/application/application.routes'),
            },
            {
                path: 'country',
                loadChildren: () =>
                    import('app/modules/country/country.routing'),
            },
            {
                path: 'role',
                loadChildren: () => import('app/modules/role/role.routing'),
            },
            {
                path: 'postcode',
                loadChildren: () =>
                    import('app/modules/postcode/postcode.routing'),
            },
            {
                path: 'user',
                loadChildren: () => import('app/modules/user/user.routing'),
            },
            {
                path: 'pe-lob',
                loadChildren: () => import('app/modules/pe-lob/pe-lob.routing'),
            },

            // {path: 'chat', loadChildren: () => import('app/modules/chat/chat.routes')},
            // {path : 'message', loadChildren: () => import('app/modules/chat-messages/chat-messages.routing')}
            // {path: 'working-hours', loadChildren: () => import('app/modules/working-hours/working-routes.routes')},
            // {path: 'work-logs', loadChildren: () => import('app/modules/work-logs/work-logs.routing')},
        ],
    },
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'generate-password',
                loadChildren: () =>
                    import(
                        'app/modules/central-auth/generate-password.routing'
                    ),
            },
          ],
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'sign-out',
                loadChildren: () =>
                    import('app/modules/auth/sign-out/sign-out.routes'),
            },
            {
                path: 'unlock-session',
                loadChildren: () =>
                    import(
                        'app/modules/auth/unlock-session/unlock-session.routes'
                    ),
            },
            {
                path: 'application',
                loadChildren: () =>
                    import('app/modules/application/application.routes'),
            },
        ],
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            // { path: 'home', loadChildren: () => import('app/modules/landing/home/home.routes') },
        ],
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver,
        },
        children: [
            {
                path: 'example',
                loadChildren: () =>
                    import('app/modules/admin/example/example.routes'),
            },
        ],
    },
    { path: '**', pathMatch: 'full', redirectTo: 'dashboard' },
];
